import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "waii_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.35 }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[70]"
          data-testid="cookie-consent">
          <div className="card-surface rounded-xl p-5 shadow-2xl border border-white/10 bg-[#0e1424]/95 backdrop-blur">
            <div className="flex items-start gap-3 mb-4">
              <Cookie className="w-5 h-5 text-[#00F0FF] shrink-0 mt-0.5" />
              <p className="text-sm text-[#cbd5e1] leading-relaxed">
                We use essential cookies to keep this site running and optional analytics cookies to improve your experience. We never use advertising or tracking cookies.
              </p>
            </div>
            <div className="flex items-center gap-3">
              <button onClick={() => choose("all")} data-testid="cookie-accept-all"
                className="flex-1 bg-[#00F0FF] text-[#04121a] font-semibold text-sm px-4 py-2.5 rounded-md hover:brightness-110 transition">
                Accept All
              </button>
              <button onClick={() => choose("essential")} data-testid="cookie-essential-only"
                className="flex-1 border border-white/15 text-sm px-4 py-2.5 rounded-md hover:border-[#00F0FF]/60 transition font-medium text-[#94A3B8]">
                Essential Only
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
